import React from "react";
import {FetchStatisticData} from "./FetchStatisticData";
import {storage} from "../firebase";

//Used for clearing the assignment number's recording data for pronunciation and flash cards
//Doesn't delete the sound from firebase,
export function HandleClearAssignmentData(classLevel, statisticChoice, assignmentNum){
    let promise = new Promise((resolve)=>{
        let page = '';
        switch(statisticChoice){
            case 'pronunciationAssignments':
                page = 'pronunciationData';
                break;
            case 'translationFCAssignments':
                page = 'translationFCData';
                break;
            case 'dialogAssignments':
                page = 'dialogData';
                break;
            case 'dialogFCAssignments':
                page = 'dialogFCData';
                break;
            case 'quizAssignments':
                page = 'quizData';
                break;
            default:
                return
        }

        //Fetches the student file in firebase
        FetchStatisticData(classLevel, statisticChoice).then((res)=>{
            let soundsToDelete = [];

            //for each student, take out the selected assignment number's data
            for(let i = 0; i < res.length; i++){
                for(let n = 0; n < res[i].assignmentNum.length; n++){
                    if(res[i].assignmentNum[n] == assignmentNum){
                        soundsToDelete.push(res[i].soundFileName[n])
                        res[i].assignmentNum.splice(n, 1);
                        res[i].soundFileName.splice(n, 1);
                        res[i].date.splice(n, 1);
                    }
                }
            }
            resolve(res)
            let newStudentData = res;
            const JSONobj = JSON.stringify(newStudentData);
            const blobObj = new Blob([JSONobj], {type: "application/json"});
            const uploadTask = storage.ref('students/10' + classLevel + '/' + page + '.json').put(blobObj);
            uploadTask.on(
                "state_changed",
                () => {
                },
                error => {
                    console.log(error)
                },
                () => {
                    storage
                        .ref('students/10' + classLevel)
                        .child(page + '.json')
                        .getDownloadURL()
                        .then(url => {
                                console.log(url);
                            }
                        )
                        .catch(e => console.log(e));
                }
            )
        })
    });
    return promise;
}
